const enum AdType {
    PREROLL = "preroll",
    MIDROLL = "midroll"
}

export default AdType;
